require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2014-03-31-ffjson-faster-json-in-go.json") })
        }
      }, "path---articles-2014-03-31-ffjson-faster-json-in-go");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2014-03-31-ffjson-faster-json-in-go!./.cache/json/articles-2014-03-31-ffjson-faster-json-in-go.json
// module id = 624
// module chunks = 231608221292675